import { render, staticRenderFns } from "./CreateChatRoomEmbedded.vue?vue&type=template&id=26a36c6d&scoped=true&"
import script from "./CreateChatRoomEmbedded.vue?vue&type=script&lang=js&"
export * from "./CreateChatRoomEmbedded.vue?vue&type=script&lang=js&"
import style0 from "./CreateChatRoomEmbedded.vue?vue&type=style&index=0&id=26a36c6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a36c6d",
  null
  
)

export default component.exports